import React from 'react';
import { Divider, Popover } from 'antd';
import MetricLabel, { MetricDescription } from 'components/MetricLabel';
import MetricValue from 'components/MetricValue';
import DimensionLabel from 'components/DimensionLabel';
import SegmentTag from 'components/SegmentTag';
import Table from 'components/Table';

import './metric-tooltip.less';
import DimensionValue from 'components/DimensionValue';
import MetricChange from 'components/MetricChange';
import { metricSupportsChange } from 'shared/utils/metricChange';

function getRow(result, rowSpan) {
  return {
    id: result.id,
    result,
    rowSpan,
  };
}

const MetricTooltipContent = ({
  metric,
  dimensions,
  row,
}) => {
  const primaryResult = row?.primaryData || row;

  const dataSource = [
    getRow(primaryResult, metric, 1 + (primaryResult.dateComparisonResults?.length || 0)),
    ...(primaryResult.dateComparisonResults || []).map(result => getRow(result, metric, 0)),
    ...(primaryResult.segmentComparisonResults || []).reduce((acc, comparisonResult) => {
      acc.push(getRow(comparisonResult, metric, 1 + (comparisonResult.dateComparisonResults?.length || 0)));
      acc.push(...(comparisonResult.dateComparisonResults || []).map(result => getRow(result, metric, 0)));
      return acc;
    }, []),
  ];

  return (
    <div className="metric-tooltip">
      <p><MetricDescription {...metric} /></p>

      <Divider className="metric-tooltip__divider" />

      {dimensions.filter(d => !d.hidden).map((dimension) => (
        <div key={dimension.name} style={{ display: 'flex', alignItems: 'center', gap: 8, justifyContent: 'space-between', padding: '0 16px 8px', borderBottom: '1px solid #ccc', flexWrap: 'wrap' }}>
          <b><DimensionLabel {...dimension} lineBreaks={false} /></b>
          <DimensionValue dimension={dimension} value={primaryResult[dimension.name]} truncate={false} />
        </div>
      ))}

      <Table
        dataSource={dataSource}
        interactive={false}
        pagination={false}
        hideHeader
        columns={[
          {
            dataIndex: ['result', 'segment'],
            render: (segment) => (
              <SegmentTag segment={segment} showDateRange />
            ),
            onCell: ({ rowSpan }) => ({
              rowSpan,
            }),
          },
          {
            dataIndex: ['result', metric.name],
            render: (_, record) => (
              <MetricValue metric={metric} row={record.result} precisionContext="tooltip" />
            ),
            type: metric.type || 'number',
          },
          {
            dataIndex: ['result', metric.name],
            render: (_, record) => (
              <MetricChange metric={metric} row={record.result} aligned={false} />
            ),
            hidden: primaryResult.dateComparisonResults?.length !== 1 || !metricSupportsChange(metric),
            type: 'number',
          },
        ]}
      />
    </div>
  );
};

const MetricTooltip = ({
  children,
  ...props
}) => (
  <Popover
    title={<MetricLabel {...props.metric} lineBreaks={false} />}
    content={<MetricTooltipContent {...props} />}
    placement="top"
    styles={{
      root: {
        minWidth: 250,
        maxWidth: 450,
      },
    }}
  >
    {children}
  </Popover>
);

export default MetricTooltip;
